export const listeCours = [
    {
        "id": 1,
        "date" : "Mis à jour il y a 2 jours",
        "titre": "Introduction au C++",
        "description": "Language de programmation compilé permettant la programmation sous de multiples paradigmes, dont la programmation procédurale, la programmation orientée objet et la programmation générique.",
        "liencours": "/cours/cpp",
        "lienexos": "/exercices/cpp",
        "image": "card-image1",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"disponible",
        "annee": 2,
    },
    {
        "id": 2,
        "date" : "Mis à jour il y a 1 jour",
        "titre": "DataScience - Python",
        "description": "Language de programmation interprété de haut niveau, utilisé pour le développement web, le développement d'applications, le traitement de données, l'IA et bien d'autres.",
        "liencours": "/cours/python",
        "lienexos": "/exercices/python",
        "image": "card-image2",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"non-disponible",
    },
    {
        "id": 3,
        "date" : "Mis à jour il y a 1 jour",
        "titre": "Electromagnétostatique",
        "description": "L'électromagnétisme est une branche de la physique qui étudie les interactions entre les particules chargées, les champs électriques et les champs magnétiques.",
        "liencours": "/cours/electromag",
        "lienexos": "/exercices/electromag",
        "image": "card-image4",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"non-disponible",
        "annee": 1,
    },
    {
        "id": 4,
        "date" : "Mis à jour il y a 1 jour",
        "titre": "Thermodynamique",
        "description": "La thermodynamique est une branche de la physique qui étudie les effets de la chaleur, du travail et de l'énergie sur un système.",
        "liencours": "/cours/thermo",
        "lienexos": "/exercices/thermo",
        "image": "card-image5",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"non-disponible",
        "annee": 1,
    },
    {
        "id": 5,
        "date" : "Mis à jour il y a 1 jour",
        "titre": "Mathématiques",
        "description": "Les mathématiques sont une science formelle qui étudie les nombres, les figures et les structures.",
        "liencours": "/cours/maths",
        "lienexos": "/exercices/maths",
        "image": "card-image6",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"non-disponible",
        "annee": 1,
    },
    {
        "id": 6,
        "date" : "Mis à jour il y a 1 jour",
        "titre": "Electrocinétique",
        "description": "L'électrocinétique est une branche de la physique qui étudie les interactions entre les charges électriques et les champs électriques.",
        "liencours": "/cours/electrocin",
        "lienexos": "/exercices/electrocin",
        "image": "card-image7",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"non-disponible",
        "annee": 1,
    },
    {
        "id": 7,
        "date" : "Mis à jour il y a 1 jour",
        "titre": "Introduction à la Dynamique",
        "description": "La dynamique est une branche de la physique qui étudie les mouvements des objets et les forces qui les provoquent.",
        "liencours": "/cours/dynamique",
        "lienexos": "/exercices/dynamique",
        "image": "card-image8",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"non-disponible",
        "annee": 1,
    },
    {
        "id": 8,
        "date" : "Mis à jour il y a 1 jour",
        "titre": "Optique géométrique",
        "description": "L'optique géométrique est une branche de la physique qui étudie les phénomènes lumineux en se basant sur des modèles simplifiés.",
        "liencours": "/cours/optiquegeo",
        "lienexos": "/exercices/optiquegeo",
        "image": "card-image9",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"non-disponible",
        "annee": 1,
    },
    {
        "id": 20,
        "date" : "???",
        "titre": "Peut-être ??",
        "description": "Contactez moi pour me proposer vos cours/exercices corrigés ! \n lucas.langrand@etu.univ-lyon1.fr",
        "lien": "/",
        "image": "card-image3",
        "button-text-exos": "Voir les corrigés",
        "button-text-cours": "Voir les cours",
        "type":"non-disponible",
    },
]